import type { ApiResponse, IGetCommunityRequest, IReorderCommunityRequest } from '../types';
import routes from '@/config/routes';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import { IBlog, IFAQ, ITestimonial } from '@/store/admin/types/types';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

const getCommunityPageConfigValues = (): ApiResponse => v3Get(routes.backendUrl.community.getConfiguration);
const getBlogs = (payload: IGetCommunityRequest): ApiResponse => v3Post(routes.backendUrl.community.getBlogs, payload);
const getFaqs = (payload: IGetCommunityRequest): ApiResponse => v3Post(routes.backendUrl.community.getFaqs, payload);
const getTestimonials = (payload: IGetCommunityRequest): ApiResponse =>
  v3Post(routes.backendUrl.community.getTestimonials, payload);
const getBlogById = (blogId: number): ApiResponse => v3Get(`${routes.backendUrl.community.getBlogById}${blogId}`);
const getFaqById = (faqId: number): ApiResponse => v3Get(`${routes.backendUrl.community.getFaqById}${faqId}`);
const getTestimonialById = (testimonialId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.community.getTestimonialById}${testimonialId}`);
const getCountriesListByClientId = (clientId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.community.getCountriesListByClientId}${clientId}`);
const archiveCommunity = (communityId: number): ApiResponse =>
  v3Post(routes.backendUrl.community.archiveCommunity.replace('{id}', communityId.toString()), null);
const unarchiveCommunity = (communityId: number): ApiResponse =>
  v3Post(routes.backendUrl.community.unarchiveCommunity.replace('{id}', communityId.toString()), null);
const reorderCommunity = (payload: IReorderCommunityRequest): ApiResponse =>
  v3Post(routes.backendUrl.community.reorderCommunity, payload);

const saveBlog = async (blog: IBlog): Promise<AxiosResponse> => {
  const fileData = jsonToFormData(blog);
  const config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return await v3Post(routes.backendUrl.community.saveBlog, fileData, config);
};

const saveFaq = async (faq: IFAQ): Promise<AxiosResponse> => {
  return await v3Post(routes.backendUrl.community.saveFaq, faq);
};

const saveTestimonial = async (testimonial: ITestimonial): Promise<AxiosResponse> => {
  return await v3Post(routes.backendUrl.community.saveTestimonial, testimonial);
};

const jsonToFormData = (data: any): FormData => {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
};

const buildFormData = (formData: any, data: any, parentKey?: string) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[][${key}]` : key);
    });
  } else {
    const value = data === null ? '' : data;

    formData.append(parentKey, value);
  }
};

export const communityAdminApis = {
  getCommunityPageConfigValues,
  getBlogs,
  getFaqs,
  getTestimonials,
  saveBlog,
  saveFaq,
  getBlogById,
  getFaqById,
  saveTestimonial,
  getTestimonialById,
  archiveCommunity,
  unarchiveCommunity,
  reorderCommunity,
  getCountriesListByClientId,
};
